"use strict";
import "lodash";
import { svc_search } from "@/services";
import dayjs from "dayjs";

const endpointBasePrefix = "logs";

const Model = {
	namespace: "m_Logs",
	state: {
		logs: [],
	},
	reducers: {
		handleFetchAll(state, { payload: { logs } }) {
			return { ...state, logs };
		},
	},
	effects: {
		*fetchErrors({ payload }, { call, put }) {
			let logs = yield call(svc_search, endpointBasePrefix, payload);
			_.forEach(logs.result, function (row) {
				row.key = row.id;
				row.log_timestamp = dayjs(row.log_timestamp).format("YYYY-MM-DD HH:mm:ss");
				row.outlet = `${row.outlet.name}`;
				row.terminal = `${row.terminal.terminal_no}`
			});

			yield put({
				type: "handleFetchAll",
				payload: { logs },
			});

			return logs;
		},
	},
	subscriptions: {},
};

export default Model;
